import { render, staticRenderFns } from "./UploadDates.vue?vue&type=template&id=0fdf3c80&scoped=true&"
import script from "./UploadDates.vue?vue&type=script&lang=js&"
export * from "./UploadDates.vue?vue&type=script&lang=js&"
import style0 from "./UploadDates.vue?vue&type=style&index=0&id=0fdf3c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf3c80",
  null
  
)

export default component.exports